export default __webpack_public_path__ + "static/media/hotpatch-logo-new.e9111632.svg";